import { ArticlePage } from '../../model/components/ArticlePage';
import { ArticlePostData } from '../../model/types/ArticlePostType';
import { PathContextProvider } from '../../PathContext';
import { ArticlePageInput } from './ArticlePageInput';

export interface StaticArticleInputProps {
    value: ArticlePostData;
    onChange?: (value: ArticlePostData) => void;
}

export const StaticArticlePostInput = ({
    value,
    onChange,
}: StaticArticleInputProps) => {
    const [frontPage] = value.pages;
    const onFrontPageChange = (page: ArticlePage) => {
        onChange?.({
            ...value,
            pages: [page],
        });
    };

    return (
        <>
            <fieldset>
                <legend>Front Page</legend>
                <PathContextProvider segment="pages">
                    <PathContextProvider segment={0}>
                        <ArticlePageInput
                            pageIndex={0}
                            value={frontPage}
                            onChange={onFrontPageChange}
                        />
                    </PathContextProvider>
                </PathContextProvider>
            </fieldset>
        </>
    );
};
